import { Container as MuiContainer } from "@material-ui/core";
import styled from "styled-components/macro";

const Container = styled(MuiContainer)`
	padding-top: ${({ theme }) => theme.spacing(2)}px;
`;

export { Container };
